/** The API's refusal codes for the centre's courses and students, and the i18n key that explains each. */

/** What the API answers when a course is refused, and what to say. */
export const COURSE_ERRORS: Record<string, string> = {
    course_internal_name_taken: "center.courses.errorInternalNameTaken",
    course_has_students: "center.courses.errorHasStudents",
    not_a_training_center: "center.courses.errorNotTraining",
    course_ends_before_it_starts: "center.courses.errorDates",
    course_phase_ends_before_it_starts: "center.courses.plan.errorDates",
    course_phase_name_required: "center.courses.plan.errorName",
    course_name_required: "center.courses.errorName",
    course_internal_name_required: "center.courses.errorInternalName",
};

/** What the API answers when a student of the batch is refused. */
export const STUDENT_ERRORS: Record<string, string> = {
    mentor_not_found: "center.students.errors.mentor_not_found",
    course_not_found: "center.students.errors.course_not_found",
    student_already_exists: "center.students.errors.student_already_exists",
    student_name_required: "center.students.errors.student_name_required",
    student_email_required: "center.students.errors.student_email_required",
    student_phone_required: "center.students.errors.student_phone_required",
    student_phone_invalid: "center.students.errors.student_phone_invalid",
    student_whatsapp_invalid: "center.students.errors.student_whatsapp_invalid",
    student_date_of_birth_invalid: "center.students.errors.student_date_of_birth_invalid",
    student_timezone_invalid: "center.students.errors.student_timezone_invalid",
    student_email_invalid: "center.students.errors.student_email_invalid",
    academic_year_invalid: "center.students.errors.academic_year_invalid",
    student_not_with_mentor: "center.students.errors.student_not_with_mentor",
    intake_value_invalid: "center.students.errors.intake_value_invalid",
    patient_not_found: "center.patients.detail.error",
    group_not_found: "center.groups.errorGeneric",
    patient_already_in_group: "center.groups.errorGeneric",
    couple_needs_two: "center.students.errors.couple_needs_two",
    couple_therapists_differ: "center.students.errors.couple_therapists_differ",
    couple_has_invalid_rows: "center.students.errors.couple_has_invalid_rows",
    in_a_group_and_a_couple: "center.students.errors.in_a_group_and_a_couple",
    couple_mixed_ownership: "center.students.errors.couple_therapists_differ",
    unit_has_sessions: "center.units.errorHasSessions",
    patient_not_in_couple: "center.groups.errorGeneric",
    group_mentors_differ: "center.students.errors.group_mentors_differ",
    group_size_out_of_range: "center.students.errors.group_size_out_of_range",
    group_has_invalid_rows: "center.students.errors.group_has_invalid_rows",
    not_a_training_center: "center.courses.errorNotTraining",
};
